import { useState } from "react";
import { toast } from "sonner";
import { motion } from "motion/react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const field = "bg-[#121212] border-white/20 rounded-none text-white focus-visible:ring-1 focus-visible:ring-[#ff5a00] focus-visible:border-[#ff5a00]";

export default function TradeIn() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", car_info: "", year: "", mileage: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const payload = {
        ...form,
        year: form.year ? parseInt(form.year, 10) : null,
        mileage: form.mileage ? parseInt(form.mileage, 10) : null,
      };
      const { data } = await api.post("/enquiries/tradein", payload);
      toast.success(data.message);
      setForm({ name: "", phone: "", email: "", car_info: "", year: "", mileage: "", message: "" });
    } catch {
      toast.error("Lähetys epäonnistui. Yritä uudelleen.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#ff5a00] mb-3">Vaihto & osto</p>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight mb-4">Myy autosi meille</h1>
        <p className="text-white/50 mb-12 leading-relaxed">
          Ostamme ja otamme vaihdossa autoja. Täytä tiedot alle, niin annamme sinulle arvion
          ja otamme yhteyttä mahdollisimman pian.
        </p>

        <motion.form onSubmit={submit} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          className="space-y-5" data-testid="tradein-form">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <Input required placeholder="Nimi" value={form.name} onChange={set("name")} className={field} data-testid="tradein-name" />
            <Input required placeholder="Puhelin" value={form.phone} onChange={set("phone")} className={field} data-testid="tradein-phone" />
          </div>
          <Input required type="email" placeholder="Sähköposti" value={form.email} onChange={set("email")} className={field} data-testid="tradein-email" />
          <Input required placeholder="Auto (merkki ja malli)" value={form.car_info} onChange={set("car_info")} className={field} data-testid="tradein-car" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <Input type="number" placeholder="Vuosimalli" value={form.year} onChange={set("year")} className={field} data-testid="tradein-year" />
            <Input type="number" placeholder="Mittarilukema (km)" value={form.mileage} onChange={set("mileage")} className={field} data-testid="tradein-mileage" />
          </div>
          <Textarea placeholder="Lisätietoja autosta" rows={5} value={form.message} onChange={set("message")} className={field} data-testid="tradein-message" />
          <button type="submit" disabled={sending} data-testid="tradein-submit"
            className="w-full bg-[#ff5a00] text-white font-mono text-xs uppercase tracking-widest px-8 py-4 hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-50">
            {sending ? "Lähetetään…" : "Pyydä arvio"}
          </button>
        </motion.form>
      </div>
    </div>
  );
}
